import React, { memo } from 'react';
import useCars from 'app/hook/cars/useCars';
import HeadInfo from 'app/components/common/HeadInfo';

import TooltipPopper from 'app/components/common/TooltipPopper';

import classNames from 'classnames/bind';
import styles from './ReportInspectImage.module.scss';

const cx = classNames.bind(styles);
const imgServerURL = process.env.REACT_APP_IMG_SERVER;

function ReportInspectImage() {
	const { base, inspect } = useCars();
	const { master, images } = inspect;

	const tagImages = (code) => {
		const item = images.filter((v) => v.type.indexOf(code) !== -1);
		const tags = item.map((v) => (
			<li key={v.type}>
				<img
					src={`${imgServerURL}${v.path}`}
					className={cx('thumb')}
					alt=""
				/>
				<p className={cx('txt')}>{v.title}</p>
			</li>
		));
		return tags;
	};

	return (
		<>
			<HeadInfo metaViewportZoom />
			<div className={cx('car_inspect')}>
				<strong className={cx('tit_car')}>
					{base.category.formYear}년식, {base.vehicleNo}
				</strong>
				<dl className={cx('info_accident')}>
					<dt>
						사고이력
						<TooltipPopper
							icon="uiico_question"
							btnStyle={{ margin: '-3px 5px 0 5px' }}
							tooltip={
								<>
									사고이력 인정은 사고로 자동차 주요 골격 부위의 판금, 용접수리 및 교환이 있는 경우로 한정합니다. 단, 쿼터패널,
									루프패널, 사이드실패널 부위는 절단, 용접 시에만 사고로 표기합니다. (후드, 프론트휀더, 도어, 트렁크리드 등 외판
									부위 및 범퍼에 대한 판금, 용접수리 및 교환은 단순수리로서 사고에 포함되지 않습니다)
								</>
							}
							iconText="사고이력 자세히보기"
						/>
					</dt>
					<dd>: {master.accdient ? '있음' : '없음'}</dd>
					<dt>
						단순수리
						<TooltipPopper
							icon="uiico_question"
							btnStyle={{ margin: '-3px 0 0 5px' }}
							tooltip="단순수리 인정은 후드, 프론트휀더, 도어, 트렁크리드 등 외판 부위 및 범퍼에 대한 판금, 용접수리 및 교환은 단순 수리로 처리"
							iconText="단순수리 자세히보기"
						/>
					</dt>
					<dd>: {master.simpleRepair ? '있음' : '없음'}</dd>
				</dl>
				<span className={cx('txt_supply')}>제시번호 {master.supplyNum}</span>
			</div>
			<div className={cx('regist_inspect')}>
				<strong className={cx('tit')}>
					본 차량의 성능 상태 점검기록부는 판매자가
					<br />
					사진으로 등록했습니다.
				</strong>
				<ul className={cx('list_regist')}>{tagImages('I')}</ul>
				<p className={cx('notice')}>
					본 페이지는 중고자동차 성능 &middot; 상태 점검 기록부의 모든 항목을 동일하게 적용하고 있으며, 항목 위치는 일부 변경되었습니다.
					<br />
					해당 내용은 판매자가 직접 입력한 내용으로 모든 책임은 판매자에게 있습니다.
				</p>
			</div>
		</>
	);
}

export default memo(ReportInspectImage);
